/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, Dispatch, SetStateAction } from 'react';

import BalloonEditor from '@ckeditor/ckeditor5-build-balloon';
import CKEditor from '@ckeditor/ckeditor5-react';
import { Grid, Box } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import '../../themes/editor.css';

import { IDynamicFieldsConfig } from 'components/DynamicFields/types';
import DynamicFields from '../DynamicFields';
import './ckeditor.css';
import useStyles from './styles';
import { UploadAdapter } from './UploadAdapter';

interface ITextEditorProps {
  content: string;
  setContent: Dispatch<SetStateAction<string>>;
  errorContent: boolean;
  siteDomain: string;
  dynamicFieldsList: string;
  dynamicFieldsConfig: IDynamicFieldsConfig;
  onWordCountChanged?: (wordCount: number) => void;
}

const TextEditor: React.FC<ITextEditorProps> = ({
  content,
  setContent,
  errorContent,
  siteDomain,
  dynamicFieldsList,
  dynamicFieldsConfig,
  onWordCountChanged,
}) => {
  const classes = useStyles();

  const [wordsCount, setWordsCount] = useState(0);
  const [charsCount, setCharsCount] = useState(0);
  const [error, setError] = useState(false);
  const [currentEditor, setCurrentEditor] = useState(window.editor);

  useEffect(() => {
    setError(errorContent);
  }, [errorContent]);

  useEffect(() => {
    // eslint-disable-next-line no-unused-expressions
    onWordCountChanged?.(wordsCount);
  }, [wordsCount]);

  const onInitEditor = (editor: any, siteDomain: string) => {
    window.editor = editor;
    const wordCountPlugin = editor.plugins.get('WordCount');
    setWordsCount(wordCountPlugin.words);
    setCharsCount(wordCountPlugin.characters);
    setCurrentEditor(editor);
    // eslint-disable-next-line no-param-reassign
    editor.plugins.get('FileRepository').createUploadAdapter = (
      loader: any,
    ) => {
      return new UploadAdapter(loader, siteDomain);
    };
  };

  const onChangeEditor = (editor: any) => {
    setError(false);
    const wordCountPlugin = editor.plugins.get('WordCount');
    setWordsCount(wordCountPlugin.words);
    setCharsCount(wordCountPlugin.characters);
    const data = editor.getData();

    // eslint-disable-next-line no-param-reassign
    editor.plugins.get('FileRepository').createUploadAdapter = (
      loader: any,
    ) => {
      return new UploadAdapter(loader, siteDomain);
    };

    setContent(data);
  };

  const editorConfig = {
    toolbar: [
      ['Heading'],
      ['Link'],
      ['Bold'],
      ['Italic'],
      ['ImageUpload'],
      ['BulletedList'],
      ['NumberedList'],
      ['mediaEmbed'],
      ['BlockQuote'],
    ],
    resize_enabled: true,
    heading: {
      options: [
        {
          model: 'paragraph',
          title: 'Paragraph',
          class: 'ck-heading_paragraph',
        },
        {
          model: 'heading2',
          view: 'h2',
          title: 'Heading 2',
          class: 'ck-heading_heading2',
        },
        {
          model: 'heading3',
          view: 'h3',
          title: 'Heading 3',
          class: 'ck-heading_heading3',
        },
        {
          model: 'heading4',
          view: 'h4',
          title: 'Heading 4',
          class: 'ck-heading_heading4',
        },
      ],
    },
    image: {
      resizeImage: true,
      toolbar: [
        'imageStyle:alignLeft',
        'imageStyle:alignCenter',
        'imageStyle:alignRight',
      ],
      styles: ['alignCenter', 'alignLeft', 'alignRight'],
      resizeUnit: 'px',
    },
    link: {
      addTargetToExternalLinks: false,
      isExternal: {
        mode: 'automatic',
        callback: (url: string) => url.startsWith('http://'),
        attributes: {
          target: '_blank',
          rel: 'noopener noreferrer',
        },
      },
      decorators: [
        {
          mode: 'manual',
          label: 'Reference link',
          attributes: {
            name: 'referenceLink',
          },
        },
      ],
    },
    mediaEmbed: {
      previewsInData: true,
    },
  };

  return (
    <>
      <Grid item xs={12} className={classes.editor}>
        {dynamicFieldsConfig.showDynamicFields && (
          <DynamicFields
            dynamicFieldsList={dynamicFieldsList}
            dynamicFieldsConfig={dynamicFieldsConfig}
            editor={currentEditor}
          />
        )}
        {error && (
          <Box mb={3} pt={1}>
            <Alert severity="error">Content must be added!</Alert>
          </Box>
        )}
        <Box id="ckeditor">
          <CKEditor
            editor={BalloonEditor}
            disabled={false}
            data={content || ''}
            onInit={(editor: any) => onInitEditor(editor, siteDomain)}
            config={editorConfig}
            onChange={(_: any, editor: any) => onChangeEditor(editor)}
            // onFocus={(_: any, editor: any) => onFocusEditor(editor)}
          />
        </Box>
      </Grid>
      <Grid className={classes.infoText} item xs={12}>
        <Box>
          <span>&nbsp; Characters: {charsCount}</span>
          &nbsp; |
          <span>
            &nbsp; Words:
            {wordsCount}
          </span>
        </Box>
      </Grid>
    </>
  );
};

export default TextEditor;
